module.exports = __webpack_public_path__ + "img/property.0aefa571.jpeg";